import styled from 'styled-components';
import { StyleColor } from '../../utils/styles-constants';
import { Button } from '../../components/Button/styles';

interface SwitcherProps {
	isOpen: boolean;
}

const pageMargin = '25px';

const LanguageSwitcherContainer = styled('div')`
	width: calc(100% - ${pageMargin});
	display: flex;
	justify-content: flex-end;
	text-align: right;
	position: relative;
	padding-top: ${pageMargin};
	padding-right: ${pageMargin};

	> button svg {
		transition: 0.2s;
		transform: ${(props: SwitcherProps) => props.isOpen ? 'rotate(180deg)' : 'rotate(0)'};
	}

	> div {
		transition: 0.2s;
		right: ${pageMargin};
		${(props: SwitcherProps) => props.isOpen
			?	`z-index: 2;
				opacity: 1;
				top: calc(42px + ${pageMargin});`
			: 	`z-index: -1;
				opacity: 0;
				top: calc(40px + ${pageMargin});`
		}
	}
`;

const LanguageSwitcherButton = styled(Button)`
	width: 90px;
	height: 33px;
	border-radius: 24px;
	color: ${StyleColor.White};
	background-color: ${StyleColor.Blue500};
	border: 1px solid ${StyleColor.Blue500};
	position: relative;
	padding-right: 25px;
	letter-spacing: 0.5px;
	font-weight: 400;

	svg {
		position: absolute;
		top: 0;
		right: 18px;
		height: 33px;
		width: 15px;
		fill: ${StyleColor.White};
	}
`;

const LanguageSwitcherDropdown = styled('div')`
	position: absolute;
	right: 0;
`;

export { LanguageSwitcherContainer, LanguageSwitcherButton, LanguageSwitcherDropdown };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/LanguageSwitcher/styles.ts